import React, {PureComponent} from "react";
import withStyles from '@mui/styles/withStyles';
import moment from "moment";
import {UrlBuilder} from "../../core/url/UrlBuilder";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import WorkoutSmallNote from "./partials/WorkoutSmallNote";
import LinearProgress from "@mui/material/LinearProgress";
import Fade from "@mui/material/Fade";
import Skeleton from '@mui/material/Skeleton';
import WorkoutCompleteEditForm from "./partials/WorkoutCompleteEditForm";
import {withRouter} from "../../hooks/withRouter";
import {createStyles} from "@mui/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import WorkoutLogsSection from "./partials/WorkoutLogsSection";
import PersonalRecordBanner from "./partials/PersonalRecordBanner";
import {UserContext} from "../../core/UserContext";
import AiChatButton from "../ai/AiChatButton";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import BarChartIcon from '@mui/icons-material/BarChart';
import TimerIcon from '@mui/icons-material/Timer';
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";

const useStyles = theme => (
createStyles({
	appBar: {
		position: 'relative',
	},
	title: {
		marginLeft: theme.spacing(1),
		flex: 100,
	},
	grow: {
		flexGrow: 1,
	},
	container: {
		backgroundColor: theme.palette.background.default,
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

class WorkoutCompleteBloop extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			workout: null,
			allExercises: [],
			isOpen: false,
			isLoading: true,
			isSubmissionLoading: false,
			workoutComment: null,
			dropDownCommentAnchorEl: null,
			isConfirmationDialogOpen: false,
			workoutsData: {},
			personalRecords: [],
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (this.state.isOpen !== nextProps.isOpen) {
			if (nextProps.isOpen) {
				this.openSelf();
			} else {
				this.setState({
					isOpen: false,
				});
			}
		}
	}

	openSelf = async () => {
		this.setState({
			isLoading: true,
			isOpen: true,
			isConfirmationDialogOpen: false,
		});

		const response = await fetch(
			UrlBuilder.workout.currentWorkoutApi()
		).then(res => res.json());

		let workout = response.data;

		this.setState({
			workout: workout,
			workoutComment: workout.comment,
			allExercises: this.getAllExercisesFromRoutine(workout),
			isLoading: false,
		});

		fetch(UrlBuilder.workout.personalRecordsApi(workout.id))
			.then(res => res.json())
			.then(res => {
				this.setState({personalRecords: res.data || []});
			});
	}

	getAllExercisesFromRoutine(workout) {
		let exercises = [];
		workout?.routines.forEach(routine => {
			routine.exercises.forEach(exercise => {
				exercises.push(exercise);
			})
		});
		return exercises;
	}

	handleFinishWorkoutButton = async (e) => {
		if (this.state.workout?.routines?.length > 0) {
			this.openConfirmationDialog(true);
		} else {
			await this.finishWorkout(e);
		}
	}

	finishWorkout = async (event) => {
		event.preventDefault();

		this.setState({
			isSubmissionLoading: true,
		});

		let workout = {
			dateTimeEnded: moment().format('L, h:mm:ss A'),
			comment: this.state.workoutComment,
		};

		await fetch(UrlBuilder.workout.finishWorkoutApi(), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(workout)
		})
			.then(response => response.json())
			.then(response => {
				this.setState({
					isSubmissionLoading: false,
				});

				let user = response.data;

				this.props.setUser(user);

				if (this.state.workout.routines.length > 0) {
					this.props.navigate(UrlBuilder.workout.workoutDetailPage(this.state.workout.id, true));
				}
			})
	}

	saveWorkoutNotes = async (event) => {
		event.preventDefault();

		let workout = {
			comment: this.state.workoutComment ?? event.target.value,
		};

		await fetch(UrlBuilder.workout.currentWorkoutApi(), {
			method: 'PUT',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(workout)
		})
	}

	setWorkoutCommentState = (event) => {
		this.setState({
			workoutComment: event.target.value ?? '',
		});
	}

	openConfirmationDialog = (isOpen) => {
		this.setState({
			isConfirmationDialogOpen: isOpen,
		});
	}

	saveCachedWorkoutsData = (data) => {
		this.setState({
			workoutsData: data,
		})
	}

	getWorkoutStats = () => {
		const workout = this.state.workout;
		const numberOfExercises = this.state.allExercises.length;
		const totalSets = this.state.allExercises.reduce((sum, ex) => sum + (ex.logs?.length || 0), 0);

		if (workout?.isPastWorkout) {
			let dateTimeMoment = moment(workout.dateTimeStarted);
			return {
				exercises: numberOfExercises,
				sets: totalSets,
				volume: workout.totalVolume,
				timeTitle: 'Started at',
				timeValue: dateTimeMoment.format('h:mm a'),
				timeDetail: dateTimeMoment.format('DD/MM/YYYY'),
				isPast: true,
			};
		}

		const dateTimeStarted = moment(workout.dateTimeStarted);
		const now = moment();
		let durationObj = moment.duration(now.diff(dateTimeStarted));
		let duration = moment.utc(durationObj.asMilliseconds()).format('HH:mm');

		return {
			exercises: numberOfExercises,
			sets: totalSets,
			volume: workout.totalVolume,
			timeTitle: 'Duration',
			timeValue: duration,
			timeDetail: dateTimeStarted.format('LT') + ' — now',
			isPast: false,
		};
	}

	getTotalLogCount = () => {
		return this.state.allExercises.reduce((sum, ex) => sum + (ex.logs?.length || 0), 0);
	}

	renderStatCard = (icon, label, value, detail) => {
		return (
			<Paper variant="outlined" sx={{
				borderRadius: 2,
				p: 1.5,
				textAlign: 'center',
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}>
				<Box sx={{ color: 'text.secondary', mb: 0.5 }}>
					{icon}
				</Box>
				<Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
					{value}
				</Typography>
				<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
					{label}
				</Typography>
				{detail && (
					<Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 10, mt: 0.25 }}>
						{detail}
					</Typography>
				)}
			</Paper>
		);
	}

	renderBody() {
		const stats = this.getWorkoutStats();
		const dateTimeStarted = moment(this.state.workout.dateTimeStarted);

		return <>
			<WorkoutCompleteEditForm
				workout={this.state.workout}
				isOpen={this.state.isConfirmationDialogOpen}
				setUser={this.props.setUser}
				closeSelfFunc={() => this.openConfirmationDialog(false)}
			/>

			<UserContext.Consumer>
				{({user}) => (
					<PersonalRecordBanner personalRecords={this.state.personalRecords} animated={true} prStyleId={user?.equippedPrStyleId} />
				)}
			</UserContext.Consumer>

			{/* Stat cards */}
			<Grid container spacing={1}>
				<Grid item xs={4}>
					{this.renderStatCard(
						<FitnessCenterIcon sx={{ fontSize: 20 }} />,
						'Exercises',
						stats.exercises,
						stats.sets > 0 ? `${stats.sets} sets` : null,
					)}
				</Grid>
				<Grid item xs={4}>
					{this.renderStatCard(
						<BarChartIcon sx={{ fontSize: 20 }} />,
						'Volume',
						stats.volume,
						'Total',
					)}
				</Grid>
				<Grid item xs={4}>
					{this.renderStatCard(
						<TimerIcon sx={{ fontSize: 20 }} />,
						stats.timeTitle,
						stats.timeValue,
						stats.timeDetail,
					)}
				</Grid>
			</Grid>

			{/* Time info */}
			<Box sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 0.75,
				mt: 2,
				mb: 0.5,
				px: 0.5,
			}}>
				<AccessTimeIcon sx={{ fontSize: 15, color: 'text.disabled' }} />
				<Typography variant="caption" sx={{ color: 'text.secondary' }}>
					Started {dateTimeStarted.fromNow()} — {dateTimeStarted.calendar()}
				</Typography>
			</Box>

			{/* Notes */}
			<TextField
				id="workout-notes"
				label="Notes"
				placeholder="How did the workout feel?"
				multiline
				fullWidth
				rows={2}
				value={this.state.workoutComment}
				variant="outlined"
				onBlur={this.saveWorkoutNotes}
				onChange={this.setWorkoutCommentState}
				size="small"
				sx={{ mt: 1.5 }}
			/>

			<Divider sx={{ my: 2.5 }} />

			{/* AI Chat */}
			<div style={{ float: 'right' }}>
				<UserContext.Consumer>
					{({user, setUser}) => (
						user.features?.includes('ai_features') &&
						<AiChatButton
							apiUrl={UrlBuilder.ai.summarizeWorkout(this.state.workout.id)}
							pageContext={`workout/${this.state.workout.id}`}
							defaultActionLabel="Summarize this workout"
							presetSuggestions={[
								"Compare to my previous workout",
								"What's my strongest lift today?",
								"Which muscles need more focus?",
								"Which lifts could I improve?",
								"Did I train hard enough?",
								"How did my volume compare to last time?",
								"Any signs I'm overreaching?",
								"What should I focus on next session?",
								"Is my rep range balanced?",
								"Did I hit any new PRs?",
							]}
						/>
					)}
				</UserContext.Consumer>
			</div>

			{/* Exercise logs */}
			<WorkoutLogsSection
				workout={this.state.workout}
				shouldUpdate={!this.state.isLoading}
				cachedWorkoutsData={this.state.workoutsData}
				saveCachedWorkoutsData={this.saveCachedWorkoutsData}
				personalRecords={this.state.personalRecords}
			/>
		</>;
	}

	hasNeverBeenFetched = () => {
		return this.state.workout === null;
	}

	renderLoadingSkeletons = () => {
		return <>
			{/* Stat cards */}
			<Grid container spacing={1}>
				{[1, 2, 3].map(i => (
					<Grid item xs={4} key={i}>
						<Paper variant="outlined" sx={{ borderRadius: 2, p: 1.5, textAlign: 'center' }}>
							<Skeleton variant="circular" width={20} height={20} sx={{ mx: 'auto', mb: 0.5 }} />
							<Skeleton variant="text" width="50%" sx={{ mx: 'auto', fontSize: 24 }} />
							<Skeleton variant="text" width="60%" sx={{ mx: 'auto', fontSize: 12 }} />
						</Paper>
					</Grid>
				))}
			</Grid>

			{/* Time info */}
			<Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 0.75 }}>
				<Skeleton variant="circular" width={15} height={15} />
				<Skeleton variant="text" width="55%" sx={{ fontSize: 12 }} />
			</Box>

			{/* Notes */}
			<Skeleton variant="rounded" height={56} sx={{ mt: 1.5, borderRadius: 1 }} />

			<Divider sx={{ my: 2.5 }} />

			{/* Exercise log skeletons */}
			{[1, 2].map(i => (
				<Box key={i} sx={{ mb: 2 }}>
					<Skeleton variant="text" width={140} sx={{ fontSize: 20, mb: 1 }} />
					{[1, 2].map(j => (
						<Box key={j} sx={{ mb: 1.5 }}>
							<Box sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}>
								<Skeleton variant="circular" width={24} height={24} sx={{ mr: 1.5 }} />
								<Skeleton variant="text" width="40%" sx={{ fontSize: 14 }} />
							</Box>
							{[1, 2, 3].map(k => (
								<Box key={k} sx={{ display: 'flex', alignItems: 'center', pl: 5, mb: 0.25 }}>
									<Skeleton variant="text" width={16} sx={{ mr: 1.5, fontSize: 13 }} />
									<Skeleton variant="text" width={`${30 + k * 10}%`} sx={{ fontSize: 13 }} />
								</Box>
							))}
						</Box>
					))}
				</Box>
			))}
		</>;
	}

	render() {
		const {classes} = this.props;
		const workout = this.state.workout;
		const hasExercises = workout?.routines?.length > 0;

		return (
			<Dialog fullScreen open={this.state.isOpen} onClose={this.props.closeSelfFunc} TransitionComponent={Transition}>
				<AppBar className={classes.appBar} enableColorOnDark>
					<Toolbar variant={"dense"}>
						<FitnessCenterIcon sx={{ fontSize: 20, mr: 1 }} />
						<Typography variant="h6" noWrap sx={{ flex: 1, fontWeight: 600 }}>
							{workout?.isPastWorkout ? 'Logging Past Workout' : 'Active Workout'}
						</Typography>

						<IconButton
							size="small"
							color="inherit"
							onClick={this.props.closeSelfFunc}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
					</Toolbar>
					<Fade in={this.state.isLoading}>
						<LinearProgress />
					</Fade>
				</AppBar>

				<DialogContent dividers className={classes.container}>
					<Container disableGutters>
						{this.hasNeverBeenFetched() ?
							this.renderLoadingSkeletons()
							: this.renderBody()
						}
					</Container>
				</DialogContent>

				<DialogActions sx={{
					px: 2,
					py: 1.25,
					gap: 1,
					borderTop: 1,
					borderColor: 'divider',
				}}>
					<Button
						variant="outlined"
						onClick={this.props.closeSelfFunc}
						sx={{ textTransform: 'none', fontWeight: 500 }}
					>
						Close
					</Button>

					<Box sx={{ flex: 1 }} />

					{workout?.isPastWorkout ? (
						<Button
							onClick={this.handleFinishWorkoutButton}
							disabled={!workout || this.state.isLoading || this.state.isSubmissionLoading}
							color="secondary"
							variant="contained"
							endIcon={hasExercises ? <MoreVertIcon fontSize="small" /> : null}
							sx={{ textTransform: 'none', fontWeight: 600 }}
						>
							{this.state.isSubmissionLoading ? (
								<><CircularProgress size={16} color="inherit" sx={{ mr: 1 }} /> Saving...</>
							) : (
								hasExercises ? 'Complete Workout' : 'Quit Workout'
							)}
						</Button>
					) : (
						<>
							{hasExercises && (
								<Button
									variant="outlined"
									onClick={() => this.openConfirmationDialog(true)}
									disabled={this.state.isLoading || this.state.isSubmissionLoading}
									sx={{ textTransform: 'none', fontWeight: 500, minWidth: 'auto', px: 1 }}
								>
									<MoreVertIcon fontSize="small" />
								</Button>
							)}
							<Button
								onClick={this.finishWorkout}
								disabled={!workout || this.state.isLoading || this.state.isSubmissionLoading}
								color="secondary"
								variant="contained"
								sx={{ textTransform: 'none', fontWeight: 600, px: 3 }}
							>
								{this.state.isSubmissionLoading && !this.state.isConfirmationDialogOpen ? (
									<><CircularProgress size={16} color="inherit" sx={{ mr: 1 }} /> Saving...</>
								) : (
									hasExercises ? 'Complete Workout' : 'Quit Workout'
								)}
							</Button>
						</>
					)}
				</DialogActions>
			</Dialog>
		);
	}
}

export default withStyles(useStyles)(withRouter(WorkoutCompleteBloop));
